import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { NonAuthRoutes} from "../url";
import image1 from "../assets/images/image.webp";
import image2 from "../assets/images/cybersecurity.jpeg"
import image3 from "../assets/dImages/Hi-Res/GreenEnergy.jpg"
import image4 from "../assets/images/consultancy.avif"


const ImageSlider = () => {
  const navigate = useNavigate();

  const slides = [
    {
      url: image1,
      title: 'Oil and Gas',
    },
    {
      url: image2,
      title: 'Cyber Security',
    },
    {
      url: image3,
      title: 'Green Energy Services',
    },
    {
      url:image4,
      title: 'Consultancy',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className='hero-banner '>
      <div className='carousel-container overflow-x-hidden'>
<div className='w-full h-[800px] relative'>
  <img
    src={slides[currentIndex].url}
    alt="bgImage"
    loading="lazy" 
    className='w-full h-full absolute top-0 left-0 object-cover duration-500'
  />
    <div className='flex justify-between items-center h-24 max-w-[1240px] mx-auto px-4 text-black'>

          <div className='text-overlay absolute top-1/2 transform -translate-y-1/2 mx-auto p-8'>
          <h1 className='banner-text text-4xl font-bold text-white'>{slides[currentIndex].title}</h1>
            <p className='subtext text-white mt-4'>Discover the best products and services.</p>
            <button className='button py-3 px-6 w-60 my-4'   onClick={() => navigate(NonAuthRoutes.Contact)}
>Get in Touch</button>      
                </div>
                </div>
        </div>


       <div className='flex top-4 justify-center py-2'>
          {slides.map((slide, slideIndex) => (
            <div
              className='text-2xl cursor-pointer'
              key={slideIndex}
              onClick={() => goToSlide(slideIndex)}
            >
            </div>
          ))}
        </div>
         
      </div>
   
    </div>
  );
};

export default ImageSlider;
